import { CoinDto } from '../../../models/dtos/coin.dto';
import axios from '../../axios';

export default async function getCoinsRequest(): Promise<CoinDto[]> {
  const response = await axios.get<CoinDto[]>(
    `${process.env.REACT_APP_BASE_URL}/users/coin`
  );
  return response.data;
}
